import { Route, Routes } from "react-router-dom";
import Layout from "./layout/Layout";
import BlogsPage from "./pages/BlogsPage";
import ContactPage from "./pages/ContactPage";
import Home from "./pages/Home";
import ProjectPage from "./pages/ProjectPage";
import ServicePage from "./pages/ServicePage";
import PageNotFound from "./utils/404";
import ProjectDetailPage from "./pages/ProjectDetailPage";


function App() {
  return (
    <div>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="blogs" element={<BlogsPage />} />
          <Route path="projects" element={<ProjectPage />} />
          <Route path="project/:id" element={<ProjectDetailPage />} />
          <Route path="service" element={<ServicePage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="*" element={<PageNotFound />}></Route>
        </Routes>
      </Layout>
    </div>
  );
}

export default App;
